import * as B from '../../BountyDetailParts'

export const BountyDetailSatisfied = ({
  data,
  ...props
}: Omit<B.PageProps, 'children'>) => {
  return (
    <B.Page data={data} {...props}>
      <B.SparkCodes />
      <B.SectionGroup>
        <B.TitleRow />
        <B.StatusCard>
          <B.StatusHeading>In Review</B.StatusHeading>
          <B.StatusParagraph>
            We are reviewing your bounty. We'll send you a message when we are
            done.
          </B.StatusParagraph>
        </B.StatusCard>
        <B.LiveVideoPreview />
      </B.SectionGroup>
      <B.OrderDetails />
      <B.CommunityRules />
    </B.Page>
  )
}
